import { useTranslation } from "react-i18next";

export default function FindNow(props){
    const { t } = useTranslation();
    return(
        <>
            <img id="find-now-image" src="home.jpg"/>
            <div className="vertical-center-element">
                <div className="white-title-text">{t('Faire estimer son bien immobilier?')}</div>
                    <br/>
                <div className="white-text">
                {t('Vous envisagez de vendre votre propriété ou d’obtenir une évaluation gratuite et non contraignante sur la valeur marchande actuelle de votre propriété?')}
                    </div>
                    <br/>
                    <br/>
                    <div className="blue-button" onClick={props.showContactsClick}>{t('Trouvez maintenant')}</div>
            </div>
        </>
    )
}
